export default "/static/build/ssl.png";